<script>
  import CATEGORY_MAP from "../categories";
  import Label from "./Label.svelte";
  import { t, lang } from "../i18n";

  const BLOCK_WIDTH = 23;
  const width = CATEGORY_MAP.length * BLOCK_WIDTH;
</script>

<svg {width} height="55" viewBox="0 0 {width} 55">
  <Label category={0} y="15" textAnchor="start" />
  <Label category={20} y="15" textAnchor="middle" />
  <Label category={40} y="15" textAnchor="middle" />
  <Label category={50} y="15" textAnchor="start" label="50+" />
  {#each CATEGORY_MAP as category, i}
    <rect x={i * BLOCK_WIDTH} y="20" width={BLOCK_WIDTH} height="23" fill={category.color} />
  {/each}

  <!-- WHO drempel -->
  <line x1={1 * BLOCK_WIDTH} y1="17" x2={1 * BLOCK_WIDTH} y2="49" stroke="#666" stroke-width="1" />
  <text text-anchor="middle" x={1.2 * BLOCK_WIDTH} y="58" font-size="11" fill="#666"
    >{t("legend-who-threshold", $lang)}</text
  >

  <!-- Europese drempel -->
  <line x1={7 * BLOCK_WIDTH} y1="17" x2={7 * BLOCK_WIDTH} y2="49" stroke="#666" stroke-width="1" />
  <text text-anchor="middle" x={7 * BLOCK_WIDTH} y="58" font-size="11" fill="#666"
    >{t("legend-eu-threshold", $lang)}</text
  >
</svg>

<style>
  svg {
    overflow: visible;
  }
</style>
